import { Loader2 } from 'lucide-react';
import type { ReactElement } from 'react';

export function FullScreenLoader(): ReactElement {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
}
